import { render, staticRenderFns } from "./AboutVue.vue?vue&type=template&id=4d1b4f66&scoped=true"
import script from "./AboutVue.vue?vue&type=script&lang=js"
export * from "./AboutVue.vue?vue&type=script&lang=js"
import style0 from "./AboutVue.vue?vue&type=style&index=0&id=4d1b4f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1b4f66",
  null
  
)

export default component.exports